<template>
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5734 0.608398H1.427C0.989496 0.608398 0.716282 1.08518 0.935925 1.46554L5.0895 8.52626V12.8227C5.0895 13.1388 5.34307 13.3941 5.65735 13.3941H10.3431C10.6574 13.3941 10.9109 13.1388 10.9109 12.8227V8.52626L15.0663 1.46554C15.2841 1.08518 15.0109 0.608398 14.5734 0.608398ZM9.63235 12.1084H6.36807V9.32268H9.63414V12.1084H9.63235ZM9.80378 7.8834L9.63414 8.17983H6.36628L6.19664 7.8834L2.65557 1.89411H13.3449L9.80378 7.8834Z"
      fill="black"
      fill-opacity="0.85"
    />
  </svg>
</template>

<script>
import IconBase from "./IconBase.vue";
export default {
  mixins: [IconBase],
};
</script>



// WEBPACK FOOTER //
// filter.vue?26b90124